module.exports = __webpack_public_path__ + "img/new_logo.7161e756.svg";